import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { SlidingTutorialMarkResponseType } from '../types/sliding-tutorial-mark-response'
import { Context } from '../shared'
import {
  SlidingTutorialMarkArgs,
  slidingTutorialMarkArgs
} from '../types/sliding-tutorial-mark-args'

export const markAsViewedSlidingTutorial: GraphQLFieldConfig<
  any,
  Context,
  SlidingTutorialMarkArgs
> = {
  description: 'Mark user onboarding tutorial as viewed.',
  type: new GraphQLNonNull(SlidingTutorialMarkResponseType),
  args: slidingTutorialMarkArgs,
  async resolve(_source, args, context) {
    const { input } = args
    if (!input) {
      throw new Error('mutation input parameter is required')
    }

    const { tutorialKey, orgUuid } = input
    const { connector } = context

    await connector.post(
      `/${orgUuid}/onboarding/tutorial/${tutorialKey}/viewed`,
      {}
    )

    return { _placeholder: true }
  }
}
